import React from 'react';
import { ComponentType, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Coin } from 'store/Coin/types';
import { fetch as fetchMarket } from 'store/Market/actions';
import { getMarketByCoinId } from 'store/Market/selectors';
import { Market } from 'store/Market/types';

interface PassedProps {
  coin: Coin;
}

interface MappedProps {
  fetchMarket: (coinId: string) => void;
  market: Market;
}

export default function withContainer<Props extends PassedProps>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Diff<Props, MappedProps>> {
  const Component = (props: Props & MappedProps) => {
    const { coin, fetchMarket } = props;

    useEffect(() => {
      fetchMarket(coin.id);
    }, [coin.id, fetchMarket]);

    return <WrappedComponent {...props} />;
  };

  const mapStateToProps = (state: any, props: Props) => {
    const getMarket = getMarketByCoinId(props.coin.id);

    return createStructuredSelector<any, { market: Market }>({
      market: getMarket,
    })(state);
  };

  const mapDispatchToProps = {
    fetchMarket,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Component as any) as any;
}
